import { render, staticRenderFns } from "./EventPage.vue?vue&type=template&id=563466c6&scoped=true"
import script from "./EventPage.vue?vue&type=script&lang=js"
export * from "./EventPage.vue?vue&type=script&lang=js"
import style0 from "./EventPage.vue?vue&type=style&index=0&id=563466c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563466c6",
  null
  
)

export default component.exports